import $ from 'jquery';

export default function viewings() {
  $(document).ready(function() {
    $('a.outbound-link').click((e) => {
      let $link = $(e.target).closest('a');
      var url = $link.attr('href');
      track_outbound_link(url);
    });
  });
}
